import { render } from "./MyCompanyAddress_EN.vue?vue&type=template&id=0baf7f6d"
import script from "./MyCompanyAddress_EN.vue?vue&type=script&lang=js"
export * from "./MyCompanyAddress_EN.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__